import { supabase } from "@/integrations/supabase/client";

/**
 * Idempotent: fills ONLY missing trial dates of the current user's manual store
 * (start = created_at, end = start + 14 days) and syncs profiles.trial_ends_at.
 * Never extends an existing or expired trial; never deletes anything.
 * Runs server-side (ensure_manual_trial) because trial columns are write-protected.
 */
export async function repairTrialState(): Promise<string | null> {
  try {
    const { data, error } = await (supabase.rpc as any)("ensure_manual_trial");
    if (error) {
      console.error("[repairTrialState] failed:", error);
      return null;
    }
    return (data as string | null) ?? null;
  } catch (err) {
    console.error("[repairTrialState] exception:", err);
    return null;
  }
}
